module.exports = __webpack_public_path__ + "img/orange_107.9dfa2858.png";